/**
 * 我销售的竞价列表页面地址
 */
export const TENDER_AUCTION_SALE_LIST_PAGE_PATH = '/auction/tender/list/sale'
